import { createAsyncThunk } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import FileDownload from 'js-file-download';
import { pushToast } from '../scanLogsSlice';

export const exportESScans = createAsyncThunk<
	void,
	ExportESScansPayload,
	{ rejectValue: string }
>('scanlogs/exportESScans', async (payload, { dispatch, rejectWithValue }) => {
	const {
		api,
		id,
		startDate,
		endDate,
		searchText,
		searchField,
		filters,
		sort,
		sortDir,
	} = payload;
	const formattedStartDate = startDate
		? DateTime.fromISO(startDate).toUTC().toFormat('yyyy-MM-dd HH:mm:ss')
		: null;

	const formattedEndDate = endDate
		? DateTime.fromISO(endDate).toUTC().toFormat('yyyy-MM-dd HH:mm:ss')
		: null;

	try {
		const result = await api.getAccountDownloadESScans(
			id,
			formattedStartDate,
			formattedEndDate,
			searchText,
			searchField,
			filters,
			sort,
			sortDir,
		);

		FileDownload(
			result,
			`scanlog_${DateTime.fromISO(startDate)
				.toLocal()
				.toFormat('MM/dd/yyyy')} - ${DateTime.fromISO(
				endDate ?? startDate,
			)
				.toLocal()
				.toFormat('MM/dd/yyyy')}.csv`,
		);
	} catch (error) {
		const message =
			error instanceof Error
				? error.message
				: 'An unexpected error occurred';
		dispatch(
			pushToast({
				type: 'error',
				message: 'Error exporting csv. Please try again later.',
			}),
		);
		return rejectWithValue(message);
	}
});

type ExportESScansPayload = {
	api: {
		getAccountDownloadESScans: (
			id: string,
			startDate: string,
			endDate: string,
			searchText: string,
			searchField: string,
			filters: string[],
			sort: string,
			sortDir: string,
		) => Promise<string>;
	};
	id: string;
	startDate: string;
	endDate: string | null;
	searchText: string;
	searchField: string;
	filters: string[];
	sort: string;
	sortDir: string;
};
